// src/pages/HomeAltas.jsx

import React from "react";
import jwt_decode from "jwt-decode";
import { Link } from "react-router-dom";
import "../css/homealtas.css";

const Icon = ({ type }) => {
  const common = {
    className: "homealtas-icon-svg",
    viewBox: "0 0 24 24",
    fill: "none",
    "aria-hidden": "true",
  };

  const strokeProps = {
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
  };

  switch (type) {
    case "cliente":
      return (
        <svg {...common}>
          <path {...strokeProps} d="M16 21v-2a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v2" />
          <circle {...strokeProps} cx="9.5" cy="7" r="4" />
          <path {...strokeProps} d="M22 21v-2a4 4 0 0 0-3-3.87" />
          <path {...strokeProps} d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      );

    case "receptor":
      return (
        <svg {...common}>
          <rect {...strokeProps} x="3" y="4" width="18" height="16" rx="2" />
          <path {...strokeProps} d="M8 10h8" />
          <path {...strokeProps} d="M8 14h5" />
          <path {...strokeProps} d="m15 15 2 2 4-4" />
        </svg>
      );

    case "localidad":
      return (
        <svg {...common}>
          <path {...strokeProps} d="M12 21s7-4.5 7-11a7 7 0 0 0-14 0c0 6.5 7 11 7 11Z" />
          <circle {...strokeProps} cx="12" cy="10" r="2.5" />
        </svg>
      );

    case "departamento":
      return (
        <svg {...common}>
          <path {...strokeProps} d="M9 18 3 21V6l6-3 6 3 6-3v15l-6 3-6-3Z" />
          <path {...strokeProps} d="M9 3v15" />
          <path {...strokeProps} d="M15 6v15" />
        </svg>
      );

    case "provincia":
      return (
        <svg {...common}>
          <path {...strokeProps} d="M4 5h16" />
          <path {...strokeProps} d="M4 12h16" />
          <path {...strokeProps} d="M4 19h16" />
          <path {...strokeProps} d="M7 3v18" />
          <path {...strokeProps} d="M17 3v18" />
        </svg>
      );

    case "categoria":
      return (
        <svg {...common}>
          <rect {...strokeProps} x="3" y="3" width="7" height="7" rx="1.5" />
          <rect {...strokeProps} x="14" y="3" width="7" height="7" rx="1.5" />
          <rect {...strokeProps} x="3" y="14" width="7" height="7" rx="1.5" />
          <rect {...strokeProps} x="14" y="14" width="7" height="7" rx="1.5" />
        </svg>
      );

    case "color":
      return (
        <svg {...common}>
          <path {...strokeProps} d="M12 22a10 10 0 1 1 10-10c0 2.2-1.8 4-4 4h-1.5a1.5 1.5 0 0 0 0 3H17a5 5 0 0 1-5 3Z" />
          <circle {...strokeProps} cx="7.5" cy="10.5" r=".5" />
          <circle {...strokeProps} cx="10.5" cy="7.5" r=".5" />
          <circle {...strokeProps} cx="14.5" cy="7.5" r=".5" />
          <circle {...strokeProps} cx="16.5" cy="10.5" r=".5" />
        </svg>
      );

    case "marca":
      return (
        <svg {...common}>
          <path {...strokeProps} d="M12 3 3 8l9 5 9-5-9-5Z" />
          <path {...strokeProps} d="m3 13 9 5 9-5" />
          <path {...strokeProps} d="m3 18 9 5 9-5" />
        </svg>
      );

    case "producto":
      return (
        <svg {...common}>
          <path {...strokeProps} d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z" />
          <path {...strokeProps} d="m3.3 7 8.7 5 8.7-5" />
          <path {...strokeProps} d="M12 22V12" />
        </svg>
      );

    case "personal":
      return (
        <svg {...common}>
          <path {...strokeProps} d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
          <circle {...strokeProps} cx="9" cy="7" r="4" />
          <path {...strokeProps} d="M22 21v-2a4 4 0 0 0-3-3.8" />
          <path {...strokeProps} d="M16 3.2a4 4 0 0 1 0 7.6" />
        </svg>
      );

    case "financiera":
      return (
        <svg {...common}>
          <rect {...strokeProps} x="3" y="6" width="18" height="12" rx="2" />
          <path {...strokeProps} d="M7 10h10" />
          <path {...strokeProps} d="M7 14h4" />
          <circle {...strokeProps} cx="17" cy="14" r="1" />
        </svg>
      );
    
    case "comisiones":
      return (
        <svg {...common}>
          <circle {...strokeProps} cx="8" cy="8" r="3" />
          <circle {...strokeProps} cx="16" cy="16" r="3" />
          <path {...strokeProps} d="M7 17 17 7" />
        </svg>
      );

    default:
      return (
        <svg {...common}>
          <circle {...strokeProps} cx="12" cy="12" r="9" />
          <path {...strokeProps} d="M12 8v4l3 2" />
        </svg>
      );
  }
};

const items = [
  {
    to: "/clientes",
    label: "Cliente Comprador",
    description: "Alta y administración de clientes que realizan la compra.",
    icon: "cliente",
  },
  {
    to: "/clientesrecepcion",
    label: "Cliente Receptor",
    description: "Datos del receptor, contacto y domicilio de entrega.",
    icon: "receptor",
  },
  {
    to: "/localidades",
    label: "Localidades",
    description: "Gestión de localidades para ordenar la operación.",
    icon: "localidad",
  },
  {
    to: "/deptos",
    label: "Departamentos",
    description: "Organización territorial por departamentos.",
    icon: "departamento",
  },
  {
    to: "/provincias",
    label: "Provincias",
    description: "Alta y mantenimiento de provincias.",
    icon: "provincia",
  },
  {
    to: "/categorias-productos",
    label: "Categorías Productos",
    description: "Clasificación comercial de productos y artículos.",
    icon: "categoria",
  },
  {
    to: "/colores",
    label: "Colores",
    description: "Catálogo de colores disponibles para productos.",
    icon: "color",
  },
  {
    to: "/marcas",
    label: "Marcas",
    description: "Gestión de marcas comerciales.",
    icon: "marca",
  },
  {
    to: "/productos",
    label: "Producto",
    description: "Alta y edición de productos del catálogo.",
    icon: "producto",
  },
  {
    to: "/personas",
    label: "Personal",
    description: "Registro del personal vinculado a la operación.",
    icon: "personal",
  },
  {
    to: "/administracion-financieras",
    label: "Financieras",
    description: "Fees, cuotas, estados y configuración de financieras.",
    icon: "financiera",
  },
];

const getRole = () => {
  const token = localStorage.getItem("token") || "";

  try {
    if (!token) return "";

    const decoded = jwt_decode(token);
    return decoded?.usuario?.role || decoded?.user?.role || decoded?.role || "";
  } catch {
    return "";
  }
};

const HomeAltas = () => {
  const role = getRole();

  const esVendedor =
    role === "VENDEDOR_ROLE";

  const esRoot =
    role === "ROOT_ROLE";

  const itemsPermitidos = esVendedor
    ? items.filter((item) =>
        [
          "/clientes",
          "/clientesrecepcion",
        ].includes(
          item.to.toLowerCase()
        )
      )
    : items.filter(
        (item) =>
          !item.soloRoot ||
          esRoot
    );

  return (
    <main className="homealtas-riders">
      <section className="homealtas-hero">
        <div className="homealtas-divider" />

        <h1>Gestiones</h1>

        <p>
          Accesos de administración para mantener clientes, productos, catálogos
          y datos operativos.
        </p>
      </section>

      <section className="homealtas-grid">
        {itemsPermitidos.map(({ to, label, description, icon }) => (
          <Link key={to} to={to} className="homealtas-card">
            <div className="homealtas-icon-box">
              <Icon type={icon} />
            </div>

            <div className="homealtas-card-body">
              <h2>{label}</h2>
              <p>{description}</p>
            </div>
          </Link>
        ))}
      </section>
    </main>
  );
};

export default HomeAltas;
